import React, { useEffect, useState } from 'react';
import { IconButton, Dialog, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import CommentIcon from '@mui/icons-material/Comment';
import CommentSection from './CommentSection.';
import { useGetAllCommentById } from '../../Hooks';
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

interface CommentModalProps {
  id:  string;
  name:  string;
  meetingId?: string;
  commentCount?: number;
}

const CommentModal: React.FC<CommentModalProps> = ({ id ,name,meetingId,commentCount}) => {
  const [open, setOpen] = useState<boolean>(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [comments, setComments] = useState<Comment[]>([]);

  return (
    <>
      {/* دکمه آیکون کامنت که مدال را باز می‌کند */}
      <IconButton onClick={handleOpen}>
      <Typography
                    fontWeight={600}
                    fontSize={"13px"}
                    variant="button"
                    // px={1}
                  >{`(${
                    commentCount
                  })`}</Typography> <CommentIcon />
      </IconButton>
    
      {/* مدال نظرات */}
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md" // عرض مدال
        fullWidth // تنظیم عرض به اندازه کل عرض صفحه
      >
        {/* محتویات مدال */}
         
        <DialogContent sx={{ p: 1 }}>
          <CommentSection id={id} name={name} meetingId={meetingId} /*commentss ={comments}*/ />
        </DialogContent>
        <IconButton
                    onClick={handleClose}
                    size={"small"}
                    sx={{
                      position: "absolute",
                      padding:1,
                      // top: "/0%",
                      left: "95%",
                      // transform: "translate(-50%, -50%)",
                    }}
                >
                      <HighlightOffIcon />
                      </IconButton>
        {/* اکشن‌های مدال */}
        <DialogActions sx={{ justifyContent: 'flex-end', padding: '16px 24px' }}>
          <Button onClick={handleClose} variant="outlined" color="primary">
            بستن
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CommentModal;
